import React, { useState } from 'react'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../../context/MatchScreenContext'

type Props = {
  question: string
  prompt: string
  submitLabel: string
  expanded: boolean
  onSubmit: () => void
}

export const CsatTextarea = ({ question, prompt, submitLabel, expanded, onSubmit }: Props) => {
  const [comment, setComment] = useState('')
  const { state: { pageKey } } = useMatchScreen()

  const handleSubmit = () => {
    trackEvent('FeedbackModule', 'CSAT Comment', {
      page_key: pageKey,
      comment,
      question
    })
    onSubmit()
  }

  return (
    <div className={`csat-module__textarea${expanded ? ' csat-module__textarea--expanded' : ''}`}>
      <p>{prompt}</p>
      <textarea
        value={comment}
        onChange={e => setComment(e.target.value)}
        maxLength={150}
      />
      <button onClick={handleSubmit}>{submitLabel}</button>
    </div>
  )
}
